export default "__VITE_ASSET__CAc1K4NQ__"